<div class="profile-container">
  <div class="profile-header">
    <button mat-icon-button class="back-button" (click)="goBack()" aria-label="Go back">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="profile-title">My Profile</h1>
  </div>

  <div class="profile-content">
    <mat-card class="profile-card" [class.editing]="isEditing()">
      <mat-card-header>
        <div class="profile-avatar">
          <mat-icon class="avatar-icon">person</mat-icon>
        </div>
        <mat-card-title class="profile-name">{{ customerName() || userFullName() }}</mat-card-title>
        <mat-card-subtitle class="profile-email">{{ customerEmail() || userEmail() }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div class="profile-info">
          <div class="info-section">
            <h3 class="section-title">Personal Information</h3>
            
            @if (isLoading()) {
              <div class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Loading profile information...</p>
              </div>
            } @else if (isEditing()) {
              <form [formGroup]="profileForm" class="edit-form">
                <div class="form-row">
                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Full Name</mat-label>
                    <input matInput formControlName="name" placeholder="Enter full name">
                    @if (profileForm.get('name')?.invalid && profileForm.get('name')?.touched) {
                      <mat-error>Full name is required and must be at least 2 characters</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Email Address</mat-label>
                    <input matInput formControlName="emailAddress" type="email" placeholder="Enter email address">
                    @if (profileForm.get('emailAddress')?.invalid && profileForm.get('emailAddress')?.touched) {
                      <mat-error>Please enter a valid email address</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Mobile Number</mat-label>
                    <input matInput formControlName="mobileNumber" placeholder="Enter mobile number">
                    @if (profileForm.get('mobileNumber')?.invalid && profileForm.get('mobileNumber')?.touched) {
                      <mat-error>Please enter a valid 10-digit mobile number</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="form-row">
                  <!-- <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Password</mat-label>
                    <input matInput [type]="showPassword() ? 'text' : 'password'" formControlName="password" placeholder="Enter password">
                    <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button" [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
                      <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    @if (profileForm.get('password')?.invalid && profileForm.get('password')?.touched) {
                      <mat-error>Password is required</mat-error>
                    }
                  </mat-form-field> -->

                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Address</mat-label>
                    <textarea matInput formControlName="address" placeholder="Enter address" rows="2"></textarea>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>GST Number</mat-label>
                    <input matInput formControlName="gstNnumber" placeholder="Enter GST number">
                  </mat-form-field>
                </div>

                <div class="form-actions">
                  <button mat-button type="button" (click)="cancelEditing()" [disabled]="isUpdating()">Cancel</button>
                  <button mat-raised-button color="primary" type="button" 
                          [disabled]="profileForm.invalid || isUpdating()" (click)="saveProfile()">
                    @if (isUpdating()) {
                      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
                      Updating...
                    } @else {
                      Update Profile
                    }
                  </button>
                </div>
              </form>
            } @else {
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Customer ID</span>
                  <span class="info-value">{{ customerId() }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Full Name</span>
                  <span class="info-value">{{ customerName() || userFullName() }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Email Address</span>
                  <span class="info-value">{{ customerEmail() || userEmail() }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Mobile Number</span>
                  <span class="info-value">{{ customerMobile() || userPhone() }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Address</span>
                  <span class="info-value">{{ customerAddress() }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">GST Number</span>
                  <span class="info-value">{{ customerGstNumber() }}</span>
                </div>
              </div>

              <div class="profile-actions">
                <button mat-raised-button color="primary" (click)="startEditing()">
                  <mat-icon>edit</mat-icon>
                  Edit Profile
                </button>
              </div>
            }
          </div>

          <mat-divider class="profile-divider"></mat-divider>

          <div class="account-section">
            <h3 class="section-title">Account Actions</h3>
            <div class="action-buttons">
              <button mat-button color="warn" (click)="logout()">
                <mat-icon>logout</mat-icon>
                Logout
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div> 